import { useState, useEffect } from "react";

/**
 * useDebouncedValue
 * Delays setting the value until after the specified delay
 *
 * @param value The input value to debounce
 * @param delay The debounce delay (in ms)
 * @returns debouncedValue
 */
const useDebouncedValue = <T>(value: T, delay: number = 500): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup previous timer on value change
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebouncedValue;